import React from 'react';
import { Button } from './ui/button';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Video Background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source src="/assets/ocean-waves.mp4" type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-teal-900/40 via-emerald-800/30 to-teal-900/50"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        {/* Glass-morphism container */}
        <div className="backdrop-blur-md bg-white/10 rounded-3xl p-12 md:p-16 shadow-2xl border border-white/20">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Simple, Honest Energy
            <span className="block text-emerald-300 mt-2">for South Devon Businesses</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Friendly, clear support from a local family business. 
            We keep energy simple for the businesses that shape our community.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-white text-teal-900 hover:bg-emerald-50 px-8 py-6 text-lg rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 font-semibold"
            >
              Join the Pod
            </Button>
            <Button
              onClick={() => scrollToSection('what-we-do')}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white/20 px-8 py-6 text-lg rounded-full backdrop-blur-sm transition-all duration-300"
            >
              Learn More
            </Button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <button
          onClick={() => scrollToSection('who-we-help')}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce"
        >
          <ChevronDown className="text-white" size={32} />
        </button>
      </div>
    </section>
  );
};

export default Hero;